export class BankAccountValidationRequest {
    routingNumber!: String;
    accountNumber!: String;

}
